export const EstimatedTestLengthRangeDescriptions = {
  _schema:
    "Server-generated. Read-only. Estimated days to reach statistical significance based on current traffic.",
  low: "Server-generated. Read-only. Optimistic estimate in days. Null when insufficient data to calculate.",
  high: "Server-generated. Read-only. Conservative estimate in days. Null when insufficient data to calculate.",
} as const;

export const ExperienceAnalysisDtoDescriptions = {
  id: "Server-generated. Read-only.",
  experienceId: "References the parent experience.",
  estimatedTestLengthRange:
    "Server-generated. Read-only. Projected days to reach statistical significance based on current traffic volume.",
  analyticsViewType:
    "Scope of orders included in analytics results. Determines whether only tested products or all store orders are counted.",
} as const;

export const CreateExperienceAnalysisDtoDescriptions = {
  id: "Omit to auto-generate.",
  experienceId:
    "Omit when creating as part of a new experience -- auto-assigned from parent.",
  analyticsViewType:
    "Scope of orders included in analytics results. Determines whether only tested products or all store orders are counted.",
} as const;
